export default __webpack_public_path__ + "media/images/react_icons/property/pets-68857173c02540b1b2d9ad0138624392.svg";